import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
// Removed Tubing imports
import CreatePumpDomesticSO from "./PumpDomesticSO/CreatePumpDomesticSO";
import CreatePumpInternationalSO from "./PumpInternatinalSO/CreatePumpInternational";
import CreateAraiMfgSO from "./AraiMfgSo/CreateAraiMfgSO";
import CreateAraiMfgDomesticSO from "./AraiMfgDomesticSO/CreateAraiMfgDomesticSO";

const CreateSalesOrder = () => {
  const [productType, setProductType] = useState("");
  const [productCategory, setProductCategory] = useState("");

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <CreatePumpDomesticSO />;
      } else if (productCategory === "International") {
        return <CreatePumpInternationalSO />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <CreateAraiMfgDomesticSO />;
      } else if (productCategory === "International") {
        return <CreateAraiMfgSO />;
      }
    }
    return null;
  }

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>Add Sales Order</h6>
          <Link to="/salesOrderIndexTable/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setProductType(e.target.value);
                    setProductCategory(""); // Reset category when product type changes
                  }}
                  value={productType}
                  disabled={!!productType}
                >
                  <option value="">--Please choose an option--</option>
                  {/* Removed Tubing option */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a PO Category:</Form.Label>
                <Form.Select
                  disabled={!productType || !!productCategory}
                  value={productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
};

export default CreateSalesOrder;
